/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, count: NonNullable<unknown> }} Seat_Types_Card_Waiting_ChangeInputs */



/**
* | output |
* | --- |
* | "Empty {from} base seats becoming {to}: {count}" |
*
* @param {Seat_Types_Card_Waiting_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_waiting_change = /** @type {((inputs: Seat_Types_Card_Waiting_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_Waiting_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Freie ${i?.from}-Basisplätze, die zu ${i?.to} werden: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Empty ${i?.from} base seats becoming ${i?.to}: ${i?.count}`)
});